export const honors = [
  {
    id: 1,
    title: 'First Class Honors Degree',
    issuer: 'University of Sunderland',
    date: 'Nov 2024',
    description: 'Summa Cum Laude First Class Degree in Computer Systems Engineering',
    details: [
      'Android Mobile Development - 97%',
      'Artificial Intelligence - 87%',
      'Product Development - 81%',
      'Advanced Cyber Security - 84%',
      'Research - 87%',
      'Advanced Database Technologies - 51%',
    ],
  },
  {
    id: 2,
    title: "MOTSHAMEKO O PHEPA MASTER'S DEGREE SCHOLARSHIP BENEFICIARY",
    issuer: 'Gambling Authority Botswana',
    date: 'Sep 2024',
    description:
      'Leveraging Open-Source Intelligence, Machine Learning, and Artificial Intelligence to Mitigate Problematic Gambling Behavior',
    details: [],
  },
];
